<ng-template #defaultTabButtons let-c="close" let-d="dismiss">

    <div class="backgroundTable text-white" ngbAutofocus>

    <div class=" mx-5 ">
        <div class="row my-2">
          <div class="col-9 align-self-center p-2 bd-highlight">Formalización Completa</div>

          <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
        </div>
      </div>
    <div class="componente-importantes-from componente-importantes-from-popup">
        <div class="row mx-5 ">
            <div *ngIf="filterProjectInfoDto.userAttachments != ''" class="col-md-12 my-2">
                <label class="form-label">Cargado por: {{filterProjectInfoDto.userAttachments}}</label>
            </div>
            <div *ngIf="filterProjectInfoDto.userAttachments != ''" class="col-md-12 my-2">
                <label class="form-label">Fecha de Carga: {{filterProjectInfoDto.dateAttachments | date:'dd/MM/yyyy' }}</label>
            </div>
            <div *ngIf="filterProjectInfoDto.userAttachments != ''" class="col-md-12 my-2">
                <label class="form-label">Descripcion {{filterProjectInfoDto.titleAttachments}}</label>
            </div>
            <div *ngIf="filterProjectInfoDto.userAttachments == ''" class="col-md-12 my-2">
                <label class="form-label">Sin Informacion</label>
            </div>
        </div>
    </div>
  </div>

</ng-template>
